export default class Form {
    constructor(fields) {
        this.fields = fields;
        this.validators = {
            required: Form.validateRequired,
            numeric: Form.validateNumeric,
            month: Form.validateMonth,
            year: Form.validateYear,
        };
        this.messages = {
            required: '%field% can\'t be blank.',
            numeric: '%field% should be a number.',
            month: '%field% should be a valid month.',
            year: '%field% should be a valid year.',
        };
    }

    validate(data) {
        const results = {};

        Object.entries(this.fields).forEach(field => {
            const name = field[0];
            const label = field[1]['label'];
            const validators = field[1]['validators'];
            const result = this.validateField(label, validators, data[name]);

            if (result !== true) {
                results[name] = result;
            }
        });

        return Object.keys(results).length > 0 ? results : true;
    }

    addValidator(name, message, func) {
        this.messages[name] = message;
        this.validators[name] = func;
    }

    validateField(label, validators, data) {
        let response = true;
        validators.forEach(validator => {
            if (response !== true) {
                return;
            }

            if (this.validators[validator](data) !== true) {
                response = this.messages[validator].replace('%field%', label);
            }
        });

        return response;
    }

    static validateRequired(data) {
        return typeof data !== 'undefined' && data !== null;
    }

    static validateNumeric(data) {
        return !isNaN(parseInt(data, 10));
    }

    static validateMonth(data) {
        const parsed = parseInt(data, 10);
        return !isNaN(parsed) && parsed >= 1 && parsed <= 12;
    }

    static validateYear(data) {
        const parsed = parseInt(data, 10);
        const year = new Date().getFullYear();
        return !isNaN(parsed) && parsed >= (year - 15) && parsed <= (year + 25);
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/form.jsx